// Lib
import { createAction } from '@reduxjs/toolkit';

export const UpdateRating = createAction('UPDATE_RATING');
export const UpdateProductsRating = createAction('UPDATE_PRODUCTS_RATING');
export const SetRating = createAction('SET_RATING');
